import { FC } from 'react';
import cn from 'classnames';

import { Card, LinkInput } from './Card';
import style from './Grid.module.scss';

interface Props {
  locale: string;
  links: LinkInput[];
}

export const Grid: FC<Props> = ({ locale, links }) => {
  if (links.length === 0) {
    return null;
  }

  return (
    <div className={style.row}>
      <div className={cn('u-wrapper', style.container)}>
        <div className={style.grid}>
          {links.map((link, index) => {
            const key = index;
            return <Card key={key} locale={locale} {...link} />;
          })}
        </div>
      </div>
    </div>
  );
};
